import { FormattedMessage, IntlShape } from "react-intl";
import Badge from "components/v2/Badge/Badge";
import { ReactComponent as ChevronDown } from "assets/images/iconsV2/chevron-down.svg";
import { ReactComponent as Triangle } from "assets/images/iconsV2/triangle-alert.svg";
import { UnitSystemPreferences } from "types/Common";

function getPackingListColumn(
  intl: IntlShape,
  isTemperatureControlRequired: string[],
  isDangerousGood: string[],
  goodsConfirmationType: string[],
  handleQRClick: (e: any, referenceNumber: string) => void,
  packingListConfig: any,
  unit_system_preferences: UnitSystemPreferences,
) {
  const columns = [
    {
      Header: (
        <div className="d-flex justify-content-between w-100" style={{ minWidth: "372px" }}>
          <span>
            <FormattedMessage id="new-request.packing-list.unit" defaultMessage="Unit" />
          </span>
          <span>
            <FormattedMessage id="new-request.packing-list.ofUnits" defaultMessage="# of units" />
          </span>
        </div>
      ),
      accessor: "Unit/units",
      Cell: ({ row }: any) => {
        const { quick_request_reference } = row?.original?.data?.organization || {};
        return (
          <div className="d-flex">
            <span>
              {row?.isExpanded ? (
                <ChevronDown height="20" width="20" transform="rotate(180)" />
              ) : (
                <ChevronDown width="20" height="20" />
              )}
            </span>
            <span className="d-flex justify-content-between ml-4">
              <div
                className="text-brand-secondary"
                onClick={(e) => handleQRClick(e, row?.original?.data?.organization?.quick_request_reference)}
              >
                {row?.original?.data?.organization?.quick_request_reference}
              </div>
              {goodsConfirmationType?.includes(quick_request_reference) && packingListConfig?.good_list_estimation_enabled && (
                <div className="packing-list-unfinalised-warning">
                  <Badge
                    color="warning"
                    type="status-badge"
                    variant="icon-leading"
                    icon={<Triangle width={12} height={12} />}
                    label={intl.formatMessage({
                      id: "new-request.packing-list.packingListNotFinalised",
                      defaultMessage: "Packing list not finalised",
                    })}
                  />
                </div>
              )}
            </span>
          </div>
        );
      },
    },
    {
      Header: (
        <div className="d-flex justify-content-between w-100">
          <span className="unit-weight">
            <FormattedMessage id="new-request.packing-list.unitWeight" defaultMessage="Unit weight" /> (
            {unit_system_preferences === "inch-lbs" ? "lbs" : "kg"})
          </span>
          <span>
            <FormattedMessage id="new-request.packing-list.unitVolume" defaultMessage="Unit volume" /> (m<sup>3</sup>)
          </span>
        </div>
      ),
      accessor: "unit-weight/unit-value",
      Cell: ({ row }: any) => {
        const { quick_request_reference } = row?.original?.data?.organization || {};
        return (
          <div className="w-340-px d-flex justify-content-end flex-wrap text-xs">
            {isTemperatureControlRequired?.includes(quick_request_reference) && (
              <Badge
                color="indigo"
                type="category-badge"
                label={intl.formatMessage({
                  id: "new-request.packing-list.temperatureControlled",
                  defaultMessage: "Temperature controlled",
                })}
              />
            )}
            {isDangerousGood?.includes(quick_request_reference) && (
              <div className="ml-2">
                <Badge
                  color="secondary-orange"
                  type="category-badge"
                  label={intl.formatMessage({ id: "general.dangerous", defaultMessage: "Dangerous" })}
                />
              </div>
            )}
          </div>
        );
      },
    },
  ];

  return columns;
}

export default getPackingListColumn;
